// @ts-nocheck

import { request } from '../context';
import type { ApiOptions } from '../context';
import type {
    GetOuterApiConfigsQuery,
    BaseResponseListOuterApiConfigFoundResponse,
    PostOuterApiConfigsBody,
    BaseResponseOuterApiConfigFoundResponse,
} from '../types';

/**
 * findAll
 *
 * @export
 * @tags 语义智能-外部接口配置
 * @link [GET] /outerApiConfigs
 */
export function getOuterApiConfigs(): Promise<BaseResponseListOuterApiConfigFoundResponse>;
export function getOuterApiConfigs(
    options: ApiOptions<never, GetOuterApiConfigsQuery>
): Promise<BaseResponseListOuterApiConfigFoundResponse>;
export function getOuterApiConfigs(
    options?: ApiOptions<never, GetOuterApiConfigsQuery>
): Promise<BaseResponseListOuterApiConfigFoundResponse> {
    return request<never, never, GetOuterApiConfigsQuery>('/outerApiConfigs', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getOuterApiConfigs',
    });
}

/**
 * save
 *
 * @export
 * @tags 语义智能-外部接口配置
 * @link [POST] /outerApiConfigs
 */
export function postOuterApiConfigs(
    data: PostOuterApiConfigsBody
): Promise<BaseResponseOuterApiConfigFoundResponse>;
export function postOuterApiConfigs(
    data: PostOuterApiConfigsBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseOuterApiConfigFoundResponse>;
export function postOuterApiConfigs(
    data: PostOuterApiConfigsBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseOuterApiConfigFoundResponse> {
    return request<PostOuterApiConfigsBody, never, never>('/outerApiConfigs', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postOuterApiConfigs',
    });
}

export const meta = [
    { tags: ['语义智能-外部接口配置'], path: '/outerApiConfigs', method: 'get' },
    { tags: ['语义智能-外部接口配置'], path: '/outerApiConfigs', method: 'post' },
];
